export var nativeFunctions = {};
